import * as Yup from 'yup'

const loginSchema = Yup.object().shape({
  usuario: Yup.string().required('Preencha o Usuário'),
  senha: Yup.string().required('Preencha a Senha'),
  tokenMFA: Yup.string()
    .required('Preencha o Token')
    .matches(/^\d{6}$/, 'O token deve ter exatamente 6 dígitos.')
})

export { loginSchema }
